import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ReactComponent as ErrorIcon } from "./assets/icons/error.svg";

const ErrorBoundary = () => {
  const error = useRouteError();
  console.error("ErrorBoundary caught:", error);
  const [title, setTitle] = useState("خطا");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (isRouteErrorResponse(error)) {
      if (error.status === 599) {
        setTitle("عدم اتصال به اینترنت");
        setMessage(
          "دسترسی شما به اینترنت قطع است یا از وی پی ان استفاده می‌کنید."
        );
      } else {
        setTitle(`خطای ${error.status}`);
        setMessage(error.data || "مشکلی در ارتباط با سرور رخ داده است.");
      }
    } else {
      setTitle("خطایی رخ داده است");
      // Extract safe message
      let errorMessage = "مشکلی در سیستم رخ داده است. لطفاً صفحه را رفرش کنید.";

      if (error?.message && typeof error.message === "string") {
        // Hide technical React errors from users
        if (
          !error.message.includes("React") &&
          !error.message.includes("hydrat") &&
          !error.message.includes("component")
        ) {
          errorMessage = error.message;
        }
      }

      setMessage(errorMessage);
    }
  }, [error]);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Box>
        <ErrorIcon />
      </Box>

      <Box textAlign="center">
        <Typography variant="h5" fontWeight={900} color={"error.main"}>
          {title}
        </Typography>
      </Box>

      <Box textAlign="center" px={2}>
        <Typography variant="body1" fontWeight={600} color={"text.secondary"}>
          {message}
        </Typography>
      </Box>

      <Box mt={2}>
        <Button variant="contained" color="primary" onClick={handleRefresh}>
          بارگذاری مجدد صفحه
        </Button>
      </Box>
    </Box>
  );
};

export default ErrorBoundary;
